const ecommmercehero=()=>{
    return(
        <>
            <div className="coontainer-fluid">
                <div className="container ecommerceheropic">

                </div>

                <h1 className="display-1 mobileTextecommerceheader" style={{position:'absolute', color:'#ffffff', marginLeft:'550px', marginTop:'-370px', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>ECOMMERCE DEVELOPMENT</h1>

            </div>
        </>
    )
}

export default ecommmercehero